var React = require('react');

function Book (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M10 3.33325H13.3333C13.7015 3.33325 14 3.63173 14 3.99992V10.6666C14 11.0348 13.7015 11.3333 13.3333 11.3333H10.4037C9.73499 11.3333 9.11053 11.6675 8.7396 12.2239L8 13.3333V5.33325C8 4.22868 8.89543 3.33325 10 3.33325Z","stroke":"currentColor","strokeWidth":"1.3","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M6 3.33325H2.66667C2.29848 3.33325 2 3.63173 2 3.99992V10.6666C2 11.0348 2.29848 11.3333 2.66667 11.3333H5.5963C6.26501 11.3333 6.88947 11.6675 7.2604 12.2239L8 13.3333V5.33325C8 4.22868 7.10457 3.33325 6 3.33325Z","stroke":"currentColor","strokeWidth":"1.3","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

Book.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = Book;

Book.default = Book;
